import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/header-popup.png'
import _imports_1 from '../../assets/images/recoveryMail/sendRecMail.png'


const _withScopeId = n => (_pushScopeId("data-v-e000f776"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "modal-title text-center" }, [
    /*#__PURE__*/_createElementVNode("header", null, [
      /*#__PURE__*/_createElementVNode("img", {
        class: "inline-block logo",
        alt: "Taykus logo",
        src: _imports_0
      })
    ])
  ])
], -1))
const _hoisted_3 = { class: "mt-4" }
const _hoisted_4 = { class: "mt-4" }
const _hoisted_5 = { class: "flex justify-center w-full mt-8 input-component" }
const _hoisted_6 = ["value", "disabled"]
const _hoisted_7 = { class: "mt-2" }
const _hoisted_8 = {
  id: "loginError",
  class: "flex justify-center w-full mt-4"
}
const _hoisted_9 = { class: "form-error" }
const _hoisted_10 = {
  key: 1,
  class: "mt-14"
}
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h4", { class: "modal-title text-center" }, [
    /*#__PURE__*/_createElementVNode("header", null, [
      /*#__PURE__*/_createElementVNode("img", {
        class: "inline-block logo",
        alt: "Mail send",
        src: _imports_1
      })
    ])
  ])
], -1))
const _hoisted_12 = { class: "mt-4" }
const _hoisted_13 = { class: "mt-4" }
const _hoisted_14 = { class: "flex justify-center w-full mt-8 input-component" }
const _hoisted_15 = ["value", "disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputEmail = _resolveComponent("InputEmail")!
  const _component_InputPassword = _resolveComponent("InputPassword")!

  return (_ctx.showForm)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.recoverTitle), 1),
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.recoverMsg), 1),
        _createElementVNode("form", null, [
          (_ctx.phase === 0)
            ? (_openBlock(), _createBlock(_component_InputEmail, {
                key: 0,
                modelValue: _ctx.email,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.email) = $event))
              }, null, 8, ["modelValue"]))
            : (_openBlock(), _createBlock(_component_InputPassword, {
                key: 1,
                onPasswordValidated: _ctx.handlePasswordValidated
              }, null, 8, ["onPasswordValidated"])),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("input", {
              type: "button",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.sendRecovery && _ctx.sendRecovery(...args))),
              value: _ctx.recoverSend,
              disabled: _ctx.hasErrors,
              class: _normalizeClass({ 'button-disabled': _ctx.hasErrors, '': true })
            }, null, 10, _hoisted_6)
          ]),
          (_ctx.phase === 0)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: "mt-4 cursor-pointer",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
              }, [
                _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("back_to_login")), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.loginError), 1)
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("h3", _hoisted_12, _toDisplayString(_ctx.$t("recover_email_send")), 1),
        _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$t("check_email_message")), 1),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("input", {
            type: "button",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
            value: _ctx.$t('back_to_login'),
            disabled: _ctx.hasErrors,
            class: _normalizeClass({ 'button-disabled': _ctx.hasErrors, '': true })
          }, null, 10, _hoisted_15)
        ])
      ]))
}